import {ITEM_PER_PAGE} from "config/_pagination";
import {DEFAULT_PRODUCT_LIST_FILTERS} from "utils/listingDefaultFilters";

const ACCOUNTING = '/accounting';
const ATTRIBUTES = '/attributes';
const BRANDS = '/brands';
const AUTHENTICATION_ACCEPT_INVITATION = '/authentication/accept-invitation/';
const CANCELLATION_REASONS = '/cancellation_reasons';
const CATEGORIES = '/categories';
const COMPLETE_PROFILE = '/completeprofile';
const COMPLIANCE = '/compliance';
const CORNERS = '/corners';
const ENRICHMENT = '/enrichment';
const ERROR = '/error';
const GENDERS = '/genders';
const INVOICE_NUMBERING = '/invoice_numbering';
const INVITATION = '/invitation/';
const LOGIN = '/login';
const LOGOUT = '/logout';
const ME = '/me';
const MEMBERS = '/members';
const MERCHANDISING = '/merchandising/products';
const NOT_FOUND = '/404';
const OPTION = '/option';
const OPTIONS = '/options';
const PERSONAL_SHOPPER = '/personal-shopper';
const RECOMMENDATIONS = '/recommendations';
const RETAILERS = '/retailers';
const ENCODED_RETAILERS = '%2Fretailers';
const RETAILER_PROFILES = '/retailer_profiles';
const RETAILER_STRIPE_CONFIRM =  '/retailers/stripe/confirm/retailer/';
const ROLES = '/roles';
const ROOT = '/';
const SECTORS = '/sectors';
const SHIPPING_METHODS = '/shipping_methods';
const SIGNIN = '/signin';
const SIGNUP = '/signup';
const STATISTICS_OPE = '/statistics/ope';
const STOCK_EASY = '/stockeasy';
const STRIPE_SIGNUP = '/signupStripe';
const VALIDATE_ACCOUNT = '/validateaccount';

export const MarketplaceRoutes = {
    ACCOUNTING,
    ATTRIBUTES,
    BRANDS,
    AUTHENTICATION_ACCEPT_INVITATION,
    CANCELLATION_REASONS,
    CATEGORIES,
    COMPLETE_PROFILE,
    COMPLIANCE,
    CORNERS,
    ENRICHMENT,
    ERROR,
    GENDERS,
    INVOICE_NUMBERING,
    INVITATION,
    LOGIN,
    LOGOUT,
    ME,
    MEMBERS,
    MEMBERS_LIST: `${MEMBERS}/${encodeURIComponent(`user[exists]=true&invitationToken[exists]=false&invitationEmail[exists]=false&itemsPerPage=${ITEM_PER_PAGE}&pagination=true&page=1`)}`,
    MERCHANDISING,
    NOT_FOUND,
    OPTION,
    OPTIONS,
    OPTION_BY_ID: (id) => `${OPTION}/${id}`,
    PERSONAL_SHOPPER,
    PERSONAL_SHOPPER_CONVERSATION: (id) => `${PERSONAL_SHOPPER}/conversations/${id}`,
    RECOMMENDATIONS,
    RETAILERS,
    RETAILERS_LIST: `${RETAILERS}/${encodeURIComponent(`order[pushActive]=desc&order[name]=asc&pagination=true&itemsPerPage=500&page=1`)}`,
    RETAILER_ATTRIBUTES_MAPPING: (id) => `${RETAILERS}/${id}/attributes-mapping`,
    RETAILER_ENRICHMENT: (id) => `${RETAILERS}/show/${id}/enrichment`,
    RETAILER_EDIT: (id) => `${RETAILERS}/edit/${id}?origin=sidebar`,
    RETAILER_FEEDS: (id) => `${RETAILERS}/show/${id}/feeds/`,
    RETAILER_MAPPING: (id) => `${RETAILERS}/show/${id}/mapping`,
    RETAILER_FEEDS_HISTORY: (retailerId, feedId) =>  `${RETAILERS}/show/${retailerId}/feeds/${feedId}/history`,
    RETAILER_FEEDS_HISTORY_IMPORT_REPORT: (retailerId, feedId, importReportId) =>  `${RETAILERS}/show/${retailerId}/feeds/${feedId}/history/${importReportId}`,
    RETAILER_FEED_MAPPER_EDIT: (retailerId, feedId, mapperId) => `${RETAILERS}/show/${retailerId}/feeds/${encodeURIComponent(feedId)}/mapper/edit/${encodeURIComponent(mapperId)}`,
    RETAILER_FEED_EDIT: (feedType, feedId) => `${feedType}/edit/${encodeURIComponent(feedId)}`,
    RETAILER_ME: (id) => `${RETAILERS}/show/${id}/me`,
    RETAILER_PRODUCT: (retailerId, productId) => `${RETAILERS}/show/${retailerId}/products/show/${productId}`,
    RETAILER_PRODUCTS: (id) => `${RETAILERS}/show/${id}/products`,
    // no order param: the list falls back to the endpoint's default ranking sort
    RETAILER_PRODUCTS_LIST: (id) => `${RETAILERS}/show/${id}/products/${encodeURIComponent([`retailer.id=${id}`, ...DEFAULT_PRODUCT_LIST_FILTERS, 'itemsPerPage=50', 'page=1'].join('&'))}`,
    RETAILER_PROFILES,
    RETAILER_PROFILE: (id) => `${RETAILER_PROFILES}/${id}`,
    RETAILER_SHOW: (id) => `${RETAILERS}/show/${id}`,
    RETAILER_SHOW_UNIQUE_RETAILER_ASSOCIATED: (id) => `${RETAILERS}/show/${ENCODED_RETAILERS}%2F${id}`, // "/%2Fretailers" feels a bit weird as it read //retailers
    RETAILER_STRIPE_CONFIRM,
    ROLES,
    ROLE_LIST: `${ROLES}/${encodeURIComponent('order[name]=asc&pagination=true&page=1')}`,
    ROOT,
    SECTORS,
    SHIPPING_METHODS,
    SIGNIN,
    SIGNUP,
    STATISTICS_OPE,
    STOCK_EASY,
    STOCK_EASY_RETAILER: (id) => `${STOCK_EASY}/retailers/${id}`,
    STOCK_EASY_SHOW_RETAILER: (id) => `${STOCK_EASY}/show/retailers/${id}`,
    STOCK_EASY_SHOW_RETAILER_PRODUCTS: (id) => `${STOCK_EASY}/show/retailers/${id}/products`,
    STRIPE_SIGNUP,
    VALIDATE_ACCOUNT,
};
